import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('activities', options)



// WEBPACK FOOTER //
// ./src/store/modules/activities.store.js